import axios from 'axios';
import { useCallback, useState } from 'react';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
export default function Login() {
  const [error, setError] = useState(null);
  const [signUpData, setSignUpData] = useState({ usuario: '', password: '' });
  const [verP, setVerP] = useState(false);
  const [cookies, setCookie] = useCookies(['user'], ['text'], ['ticket'], ['asignado']);
  const navigate = useNavigate();
  const [userFalse, setUserFalse] = useState(false);
  const userSignUpSubmit = useCallback(
    async e => {
      e.preventDefault();
      await axios.post('https://back.agsseguros.online/api/login/login', { usuario: signUpData.usuario, password: signUpData.password }).then(response => {
        if (response.data === 'Invalid OAuth') {
          setUserFalse(true);
        } else {
          setCookie('exp', JSON.stringify([]), { path: '/' });
          setCookie('user', response.data, { path: '/' });
          setCookie('asignado', JSON.stringify([]), { path: '/' });
          navigate('/');
        }
      });
    },
    /*
    async e => {
      e.preventDefault();
      await axios.post('http://localhost:8080/api/login/login', { usuario: signUpData.usuario, password: signUpData.password }).then(response => {
        if (response.data === 'Invalid OAuth') {
          setUserFalse(true);
        } else {
          setCookie('exp', JSON.stringify([]), { path: '/' });
          setCookie('user', response.data, { path: '/' });
          setCookie('asignado', JSON.stringify([]), { path: '/' });
          navigate('/');
        }
      });
    },
    */
    [signUpData, navigate, setCookie]
  );
  return (
    <main className=' center'>
      <form onSubmit={userSignUpSubmit}>
        <div>
          <input
            type='text'
            required
            value={signUpData.usuario}
            className='form-control'
            placeholder='USUARIO'
            onChange={e =>
              setSignUpData(prevState => ({
                ...prevState,
                usuario: e.target.value,
              }))
            }
          />
        </div>
        <div className='mt-3 d-flex center gap-3'>
          <input
            type={verP === false ? 'password' : 'text'}
            required
            value={signUpData.password}
            className='form-control'
            placeholder='CONTRASEÑA'
            onChange={e =>
              setSignUpData(prevState => ({
                ...prevState,
                password: e.target.value,
              }))
            }
          />
          {verP === false ? <i class='bi bi-eye-fill' onClick={() => setVerP(true)}></i> : <i class='bi bi-eye-slash-fill' onClick={() => setVerP(false)}></i>}
        </div>
        <div className={userFalse === false ? 'd-none' : 'userFalseLogin'}>
          <p className='text-danger'>Usuario y/o Contraseña incorrectos</p>
        </div>
        <div className='submitLogin center mt-5'>
          <button type='submit' className='btn btn-primary'>
            Iniciar Sesion
          </button>
        </div>
      </form>
    </main>
  );
}
